import http from './http';

// 统一 AI 模块调用。返回 { content, parsed, model, mock, tokens, warning }
export function callAI(module, input) {
  return http.post(`/ai/${module}`, input).then((r) => r.data);
}

export const getNotes = () => http.get('/notes').then((r) => r.data);

// ---- 认证 ----
export const register = (payload) => http.post('/auth/register', payload).then((r) => r.data);
export const login = (payload) => http.post('/auth/login', payload).then((r) => r.data);
export const me = () => http.get('/auth/me').then((r) => r.data.user);
export const redeem = (code) => http.post('/auth/redeem', { code }).then((r) => r.data);

// ---- 历史 ----
export const getHistory = (module = 'all') => http.get('/history', { params: { module } }).then((r) => r.data);
export const deleteHistory = (id) => http.delete(`/history/${id}`).then((r) => r.data);

// ---- 多轮对话 ----
export const createSession = (module, title) => http.post('/chat/sessions', { module, title }).then((r) => r.data);
export const getSession = (id) => http.get(`/chat/sessions/${id}`).then((r) => r.data);
export const sendTurn = (id, utterance) => http.post(`/chat/sessions/${id}/turns`, { utterance }).then((r) => r.data);
